module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/additionals/additionals-show/additionals-show.component.scss
// module id = ./src/app/views/fin/additionals/additionals-show/additionals-show.component.scss
// module chunks = main